const steps = {
  DETAILS: 1,
  GROUPS: 2,
  USERS: 3,
  DOWNLOAD: 4,
}

export default steps
